const axios = require('axios');
var querystring = require('querystring');

export default {

    data: function() {
        return {
          get languages() {
            return {
                english:{
                  lessons:"My Lessons",
                  topics:"Topics", 
                  lessonempty:"",
                  info:"Lesson Info",
                  topic:"Topic",
                  comment:"Comment",
                  send:"Send",
                  play:"Play",
                  pause:"Pause",
                  fullscreen:"FullScreen",
                  duration:"Duration",
                  start:"Start at",
                  end:"End at",
                  maxscore:"Max score",
                  watch:"Details",
                  lessongoals:"Goal",
                  lessonreqs:"Requirements",
                  lessonwhat:"What will I learn?",
                  lessonskills:"Skills",
                  extrainfo: "Additional info",
                  download:"Download",
                  files:"Files",
                  lessoncontent:"Lessons",
                  myscore:'My Score'

                },
            
                mn:{
                  lessons:"Сонгосон хичээлүүд",
                  topics:"Сэдвүүд",
                  lessonempty:"Та одоогоор ямар нэгэн хичээл үзээгүй байна.",
                  info:'Мэдээлэл',
                  topic:"Сэдэв",
                  comment: "Сэтгэгдэл",
                  send:"Илгээх",
                  play:"Видео тоглуулах",
                  pause:"Видео зогсоох",
                  fullscreen:"FullScreen",
                  duration:"Үргэлжлэх хугацаа",
                  start:"Эхлэх",
                  end:"Дуусах",
                  maxscore:"Дүгнэх дээд оноо",
                  watch:"Үзэх",
                  lessongoals:"Зорилго",
                  lessonreqs:"Шаардлагууд",
                  lessonwhat:"Эзэмшүүлэх мэдлэг",
                  lessonskills:"Хичээлээр эзэмшүүлэх хувь хүний ур чадвар, хандлага",
                  extrainfo: "Нэмэлт мэдээлэл",
                  download:"Татах",
                  files:"Файлууд",
                  lessoncontent:"Хичээлийн агуулгууд",
                  myscore: "Таны дүн"
                }
            };
          }
        }
    }
    
}
